import { render, staticRenderFns } from "./InvoiceTableSkeletonSort.vue?vue&type=template&id=c2aadca8&scoped=true"
import script from "./InvoiceTableSkeletonSort.vue?vue&type=script&lang=js"
export * from "./InvoiceTableSkeletonSort.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTableSkeletonSort.vue?vue&type=style&index=0&id=c2aadca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2aadca8",
  null
  
)

export default component.exports